import { render, staticRenderFns } from "./RegistrarUsuarios.vue?vue&type=template&id=1efcb064&"
import script from "./RegistrarUsuarios.vue?vue&type=script&lang=js&"
export * from "./RegistrarUsuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports